module.exports = __webpack_public_path__ + "static/img/icon.075eac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/icon.png
// module id = 002t
// module chunks = 0